<!-- eslint-disable max-len -->
<template>
    <div class="w-full border border-b-gray-300 p-4 px-6 flex">
        <img
            v-if="logoType === 'pelican'"
            src="../../assets/logo-pelican@2x.png"
        >

        <div class="hidden lg:!flex w-full items-center justify-end text-xl">
            <div class="font-bold uppercase flex items-center">
                Your item:
                <div class="text-2xl ml-2">
                    {{defaultUnitPriceFormatted}}
                </div>
            </div>
            <template v-if="personalizations > 0">
                <div class="px-4">+</div>
                <div class="flex items-center space-x-2">
                    <div class="text-blue-500 text-2xl">
                        <span v-if="freePersonalizations > 0" class="text-red-500 text-2xl">{{$t('FREE')}}</span>
                        <span v-if="freePersonalizations > 0 && personalizations > freePersonalizations" class="px-1">+</span>
                        <span v-if="personalizations > freePersonalizations">{{customizationsPrice}}</span>
                    </div>
                    <div class="text-sm uppercase text-gray-400">{{personalizationTitle}}</div>
                </div>
            </template>
            <div class="px-4">=</div>
            <div class="font-bold uppercase flex items-center mr-8">
                Your total:
                <div class="text-2xl ml-2">
                    {{defaultSubtotalPrice}}
                </div>
            </div>
            <primary-button
                class="max-w-[200px]"
                @click.prevent="addToCart"
            >
                {{ $t('ACTION_ADD_TO_CART') }}
            </primary-button>
            <button :aria-label="$t('MENU_CLOSE')" @click.prevent="close" class="ml-4">
                <img
                    class="cursor-pointer"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAGJlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAABJKGAAcAAAASAAAAUKABAAMAAAABAAEAAKACAAQAAAABAAAAGKADAAQAAAABAAAAGAAAAABBU0NJSQAAAFNjcmVlbnNob3SRwkG9AAAB1GlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNi4wLjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyI+CiAgICAgICAgIDxleGlmOlBpeGVsWURpbWVuc2lvbj4yNDwvZXhpZjpQaXhlbFlEaW1lbnNpb24+CiAgICAgICAgIDxleGlmOlBpeGVsWERpbWVuc2lvbj4yNDwvZXhpZjpQaXhlbFhEaW1lbnNpb24+CiAgICAgICAgIDxleGlmOlVzZXJDb21tZW50PlNjcmVlbnNob3Q8L2V4aWY6VXNlckNvbW1lbnQ+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgoUz9gRAAABq0lEQVRIDd1USYoCQRAs5wG+SD0I4nJwQVF8knPyJ+JGg3gW9eIKirviRdx9gDGdBSWtVb2M4GEmL1VGRka0nZntgh7sg/H1QW0u/Q8NBoMBKxQKv35zo9GI5b5zch012Rjn8xmhUAj1et0IW943mw08Hg+Wy6XEYxKiA/v9HuFwGJqmqdJPWK/XQyAQwGq1esLFD6UBJQ+HA2KxGIrFouBKZ7PZRDKZxGQykXICMDUgwul0QjabVZq0221kMhkMh0OhpTwtDaiCepJOp1Eulx8C/X4fiUTCVpwKbA2IdLvdEI1GUa1Wsd1u4ff7MZvNKGUbjgxIhRofj8fh8/mU02Lm5HiT1+s1u9/vzO12M9oVx2HmbMRbrRbvgy6M6/XKJ8fYEyP39W77ijqdDlKpFEhcxOVy4RPkxMTSYDqdIhKJQP8MCO3HSSNMO1CpVB6Y6mJqsFgs4PV6MZ/PVXUcIxN6gFqtZspRGtCcB4NBR9Oy2+0sTSSDRqPB//p4PDZ9qteEGOFSqfSakheNmtrtdiWiHXA8HpHP5yWaixDHM/0G0fGivaHNS/6+wQ9u7QI9QGp1+gAAAABJRU5ErkJggg=="
                />
            </button>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import PrimaryButton from '../buttons/PrimaryButton.vue';

    export default {
        components: {
            PrimaryButton,
        },
        computed: {
            ...mapState({
                subtotalPrice: (state) => state.customizer.subtotalPrice,
                defaultSubtotalPrice: (state) => state.customizer.defaultSubtotalPrice,
                customizationsPrice: (state) => state.customizer.customizationsPrice,
                personalizations: (state) => state.customizer.personalizations,
                freePersonalizations: (state) => state.customizer.freePersonalizations,
            }),
            /**
             * Current view controller.
             */
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            defaultUnitPriceFormatted() {
                return this.$store.getters.defaultUnitPriceFormatted;
            },

            /**
             * Store brand.
             */
            logoType() {
                return this.viewController?.blueprint?.custom['v-logo-type'];
            },

            personalizationTitle() {
                return this.viewController.blueprint.custom['v-personalization-product-title'];
            },

            /**
             * Current customization mode.
             */
            personalizationMethod() {
                return this.$store.state.customizer.personalizationMethod;
            },
        },

        methods: {
            close() {
                this.$store.dispatch('showExitConfirmation', true);
            },

            addToCart() {
                this.$store.dispatch('selectStep', 'review');
            },
        },
    };
</script>
